import GlobalOverlays from 'pages/Main/GlobalOverlays';

export default GlobalOverlays;
